var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBtnDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2843 6.05005H0.390625L1.48903 4.05005L15.2843 4.05005V6.05005Z",
    fill: "#D0D3D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2415 0L17.8902 5L13.2415 10H10.4434L15.0921 5L10.4434 0H13.2415Z",
    fill: "#D0D3D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBtnDisabled);
export default __webpack_public_path__ + "static/media/arrow-btn-disabled.1962232a00fc8dbada0b6d6f98c0f74c.svg";
export { ForwardRef as ReactComponent };